import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';
import * as firebase from 'firebase/app';
import 'firebase/auth';
import Home from '../views/Home.vue';
import PleuralLogs from '../views/PleuralLogs.vue';
import NivLogs from '../views/NivLogs.vue';
import BronchoscopyLogs from '../views/BronchoscopyLogs.vue';
import AppPrivacy from '../views/AppPrivacy.vue';
import AppStoresRedirect from '../views/AppStoresRedirect.vue';
import Login from '../views/Login.vue';
import Logout from '../views/Logout.vue';
import { getCurrentUser } from '../services/auth';

const firebaseConfig = {
  apiKey: process.env.VUE_APP_API_KEY,
  authDomain: process.env.VUE_APP_AUTH_DOMAIN,
  databaseURL: process.env.VUE_APP_DATABASE_URL,
  projectId: process.env.VUE_APP_PROJECT_ID,
  storageBucket: process.env.VUE_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.VUE_APP_MESSAGING_SENDER_ID,
  appId: process.env.VUE_APP_APP_ID
};

firebase.initializeApp(firebaseConfig);

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: '/',
    component: Home
  },
  {
    path: '/logs/pleural',
    name: 'Pleural logs',
    component: PleuralLogs,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/logs/niv',
    name: 'NIV logs',
    component: NivLogs,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/logs/bronchoscopy',
    name: 'Bronchoscopy logs',
    component: BronchoscopyLogs,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/logout',
    name: 'Logout',
    component: Logout
  },
  {
    path: '/app/privacy',
    component: AppPrivacy
  },
  {
    path: '/app/store-redirect',
    component: AppStoresRedirect
  }
];

const router = new VueRouter({
  routes
});

router.beforeEach(async (to, _, next) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
  const user = await getCurrentUser();

  if (requiresAuth && !user) {
    next('Login');
  } else {
    next();
  }
});

export default router;
